import { Alert, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { formatDateTime } from '@/shared/lib/format'
import { VOUCHER_ADVICE } from './voucherAdvice'
import type { ActivationVerdict } from './voucherApi'

/**
 * Faollashtirish natijasi — SARLAVHA, ISH va (bo'lsa) TAFSILOT.
 *
 * ⚠️ «Endi nima qilish kerak» qatori MAJBURIY, bezak emas: kassir
 * mijoz qarshisida turibdi va sakkiz holatning har birida boshqa ish
 * qiladi (`voucherAdvice.ts`). Yalang'och «xato» unga hech narsa
 * aytmaydi va u yagona bilgan ishini qiladi — qayta bosadi.
 */
export function VoucherResultAlert({
  verdict,
  onClose,
}: {
  verdict: ActivationVerdict | null
  onClose: () => void
}) {
  const { t } = useTranslation()
  if (verdict === null) return null

  const advice = VOUCHER_ADVICE[verdict.kind]

  /*
    ⚠️ SERVER MATNI TASHLANMAYDI — `translateError` dagi qoidaning aynan
    o'zi. Ikki holatda u YAGONA aniq ma'lumotni tashiydi: qaysi holatdan
    qaysi holatga o'tib bo'lmagani (`ILLEGAL_TRANSITION` matnida
    `(CLOSED → ACTIVE)`) va qaysi plan yo'qolgani. Ularsiz operatorga
    xabar berish uchun hech narsa qolmasdi.
  */
  const serverText =
    verdict.kind === 'LOGIN_CLOSED' || verdict.kind === 'PLAN_UNAVAILABLE'
      ? verdict.serverText
      : null

  const validUntil =
    verdict.kind === 'ACTIVATED' && verdict.voucher.expiresAt !== null
      ? t('vouchers.validUntil', { date: formatDateTime(verdict.voucher.expiresAt) })
      : null

  return (
    <Alert
      type={advice.tone}
      showIcon
      closable
      onClose={onClose}
      message={t(advice.titleKey)}
      description={
        <>
          <div>{t(advice.adviceKey)}</div>
          {validUntil ? <div>{validUntil}</div> : null}
          {/* ⚠️ «Kartaga tegilmadi» — kassirga eng qimmat qatorlardan
              biri: usiz u yaroqli kartani chiqarib tashlardi
              (`VoucherAdvice.cardIntact` izohi). */}
          {advice.cardIntact ? (
            <Typography.Text type="secondary" style={{ fontSize: 12, display: 'block' }}>
              {t('vouchers.cardIntact')}
            </Typography.Text>
          ) : null}
          {serverText ? (
            <Typography.Text type="secondary" style={{ fontSize: 12, display: 'block' }}>
              {serverText}
            </Typography.Text>
          ) : null}
        </>
      }
    />
  )
}
